import { useContext, useEffect, useState } from 'react';
import { TabContext } from '../../../Context/TabContext';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import Zaglavlje from './components/Zaglavlje';
import PanelProvider from './components/PanelProvider';
import ListProviderUsluge from './components/ListProviderUsluge';
import ListProviderTransport from './components/ListProviderTransport';
import ChartBar from './components/Charts/BarChart/BarChart';
import ChartPie from './components/Charts/PieChart/ChartPie';

const initialRnData = {
  id: 0,
};
const INITIAL_FILTER_VALUES = {
  svi: false,
  lista: [],
};
const DobitDetaljniPregled = () => {
  const { tabsData, activeComponent } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const tabData = dataLocal?.data ? dataLocal?.data : {};

  const { sendRequest: getZaposleni, data: zaposleniData } = useHttp('');
  const { sendRequest: getPanelData, data: panelData } = useHttp('');
  const { sendRequest: getListUsluge, data: listUslugeData } = useHttp('');
  const { sendRequest: getListTransport, data: listTransportData } =
    useHttp('');
  const { sendRequest: getPieData, data: pieData } = useHttp('');
  const [rnData, setRnData] = useState(initialRnData);
  const [filterValues, setFilterValues] = useState(INITIAL_FILTER_VALUES);

  useEffect(() => {
    setRnData(tabData);
  }, []);

  useEffect(() => {
    if (rnData.id > 0) {
      getZaposleni({
        url: urls.GET_ZAPOSLENI_NA_RN,
        method: 'POST',
        data: { id: rnData.id },
      });
      getPanelData({
        method: 'POST',
        url: urls.GET_DATA_PANEL,
        data: { id: rnData.id },
      });
      getPieData({
        method: 'POST',
        url: urls.GET_PIE_DATA,
        data: { id: rnData.id },
      });
    }
  }, [rnData]);

  const handlePretrazi = () => {
    getListUsluge({
      method: 'POST',
      url: urls.GET_LISTA_USLUGA,
      data: { id: rnData.id, lista: filterValues.lista },
    });
    getListTransport({
      method: 'POST',
      url: urls.GET_LISTA_TRANSPORT,
      data: { id: rnData.id, lista: filterValues.lista },
    });
  };

  return (
    <>
      <div>
        <Zaglavlje
          zaposleniData={zaposleniData}
          setFilterValues={setFilterValues}
          filterValues={filterValues}
          handlePretrazi={handlePretrazi}
        />
      </div>
      <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
        <PanelProvider panelData={panelData} />
        <ListProviderUsluge data={listUslugeData} />
        <ListProviderTransport data={listTransportData} />
      </div>
      <div
        style={{
          display: 'flex',
          marginTop: '10px',
          justifyContent: 'space-around',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <label style={{ fontSize: '20px', fontWeight: 'bold' }}>
            DOBIT PREMA TIPU
          </label>
          <ChartBar data={panelData} />
        </div>
        <div style={{ textAlign: 'center' }}>
          <label style={{ fontSize: '20px', fontWeight: 'bold' }}>
            UČEŠĆE ZAPOSLENIH U DOBITI
          </label>
          <ChartPie data={pieData} />
        </div>
      </div>
    </>
  );
};

export default DobitDetaljniPregled;
